import './css/App.css';
import Header from './components/Comp_Header.js';
import Footer from './components/Comp_Footer.js';
import HomePage from './components/HomePage.js';
// import AlbumsPage from './components/AlbumsPage.js';
import FullAlbums from './components/Comp_Albums.js';
import Work from './components/Comp_work.js';
import Resume from './components/Comp_resume.js';
import Process from './components/Comp_process.js';
import BearAdmin from './components/BearAdmin.js';
// import Upload from './components/Upload.js';
// import ProtectedRoute from './components/ProtectedRoute.js';
import { Routes, Route } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <Header />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/Works" element={<Work />} />
        <Route path="/Works/:slug" element={<Work />} />
        <Route path="/Albums" element={<FullAlbums />} />
        {/* Note: React Router v6 matches paths case-insensitively by default,
            so this can't be "/albums" - it would silently lose to "/Albums"
            above on every request regardless of casing. */}
        {/* <Route path="/my-uploads" element={<ProtectedRoute><AlbumsPage /></ProtectedRoute>} /> */}
        {/* <Route path="/upload" element={<ProtectedRoute><Upload /></ProtectedRoute>} /> */}
        <Route path="/admin" element={<BearAdmin />} />
        <Route path="/Resume" element={<Resume />} />
        <Route path="/Process" element={<Process />} />
      </Routes>

      <Footer />
    </div>
  );
}

export default App;